import { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogin = async () => {
    console.log("LOGIN CLICKED");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log("LOGIN SUCCESS");
      window.location.href = "/admin";
    } catch (error) {
      console.error("LOGIN ERROR:", error);
      alert(error.message);
    }
  };

  return (
    <div style={{ padding: 20, textAlign: "center" }}>
      <h2>Admin Login</h2>

      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ padding: 10, margin: 10 }}
      />

      <br />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ padding: 10, margin: 10 }}
      />

      <br />

      <button onClick={handleLogin} style={{ padding: 10 }}>
        Login
      </button>
    </div>
  );
}

export default Login;